import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Category, CategoryForm } from '../models';

@Injectable()
export class CategoryService {

    categoriesUrl = environment.dns + 'api/categories/';

    constructor(private http: HttpClient) { }

    getList(): Observable<Category[]> {
        return this.http.get<Category[]>(this.categoriesUrl + 'list');
    }

    getListBySociety(societyId: number): Observable<Category[]> {
        return this.http.get<Category[]>(this.categoriesUrl + 'list-by-society?societyId=' + societyId);
    }

    getOne(id: number): Observable<Category> {
        return this.http.get<Category>(this.categoriesUrl + id);
    }

    add(categoryForm: CategoryForm): Observable<Category> {
        return this.http.post<Category>(this.categoriesUrl, categoryForm);
    }

    update(categoryForm: CategoryForm): Observable<Category> {
        return this.http.put<Category>(this.categoriesUrl, categoryForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.categoriesUrl + id);
    }
}